class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.accordion__content');
    this.empty = this.summary.textContent.trim().length == 0;
    this.animation = null;
    this.closing = false;
    this.expanding = false;

    this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summary.addEventListener('click', this.onClick.bind(this));
    document.addEventListener('matchSmall', this.close.bind(this));
    document.addEventListener('unmatchSmall', this.open.bind(this));

    if (!theme.config.mqlSmall || this.empty) {
      this.details.setAttribute('open', true);
      if (this.empty) this.details.setAttribute('empty', true);
    } else if (this.dataset.open == undefined) {
      this.details.removeAttribute('open');
    }
  }

  onClick(event) {
    event.preventDefault();
    if (this.empty || !theme.config.mqlSmall) return;

    this.details.style.overflow = 'hidden';
    if (this.closing || !this.details.open) this.open();
    else this.shrink();
  }

  shrink() {
    if (!theme.config.mqlSmall || this.empty) return;

    if (!this.content) {
      this.details.removeAttribute('open');
      return;
    }

    this.closing = true;

    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 250,
      easing: 'ease'
    });

    this.animation.onfinish = () => this.onFinish(false);
    this.animation.oncancel = () => { this.closing = false; };
  }

  open() {
    if (!theme.config.mqlSmall || this.empty) {
      this.details.setAttribute('open', true);
      return;
    }

    if (!this.content) {
      this.details.setAttribute('open', true);
      return;
    }

    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.expanding = true;

    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.details.scrollHeight}px`;

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });

    this.animation.onfinish = () => this.onFinish(true);
    this.animation.oncancel = () => { this.expanding = false; };
  }

  close() {
    if (!theme.config.mqlSmall || this.empty) return;
    if (this.details.open) this.shrink();
  }

  onFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.closing = false;
    this.expanding = false;
    this.details.style.height = this.details.style.overflow = '';
  }
}

customElements.define('footer-accordion', FooterAccordion);
